import { config } from "../../config"
import { User } from "../auth/data-types"


export const changeFollowStatus = async (publicId: string, followingCurrently: boolean, token: string): Promise<any> => {
    const res = await fetch(`${config.api.urlV1}/user/${followingCurrently ? 'unfollow' : 'follow'}/`, {
        headers: {
            'Content-type': 'application/json',
            token,
        },
        method: 'POST',
        body: JSON.stringify({
            user_id: publicId,
        })
    })

    if (res.status !== 200) {
        console.log('Error following/unfollowing user', { status: res.status, text: await res.text() })
        throw new Error('response')
    }
}

export const fetchFollowers = async (targetPublicId: string | null, offset: number, limit: number, token: string): Promise<User[]> => {
    let url = `${config.api.urlV1}/profile/followers/?offset=${offset}&limit=${limit}`
    if (targetPublicId != null) {
        url += `&user_id=${targetPublicId}`
    }
    const res = await fetch(url, {
        headers: {
            'Content-type': 'application/json',
            token,
        },
        method: 'GET',
    })

    if (res.status !== 200) {
        console.log("Can't fetch followers", { status: res.status, text: await res.text() })
        throw new Error('response')
    }

    return (await res.json()).data
}

export const fetchFollowing = async (targetPublicId: string | null, offset: number, limit: number, token: string): Promise<User[]> => {
    let url = `${config.api.urlV1}/profile/following/?offset=${offset}&limit=${limit}`
    if (targetPublicId != null) {
        url += `&user_id=${targetPublicId}`
    }
    const res = await fetch(url, {
        headers: {
            'Content-type': 'application/json',
            token,
        },
        method: 'GET',
    })

    if (res.status !== 200) {
        console.log("Can't fetch followers", { status: res.status, text: await res.text() })
        throw new Error('response')
    }

    return (await res.json()).data
}
